import React, { useState } from "react";
import { Link } from "react-router";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import ImgManaged from "../../../../components/common/img-managed";
import { useTranslation } from "react-i18next";

import "./style.css";

const CourseCard = (props) => {
  const { t } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const image =
    process.env.REACT_APP_API_URL +
    "/images/covers/courses/" +
    props.course.code +
    ".jpg";

  const course = props.course;

  function toggle() {
    setDropdownOpen(!dropdownOpen);
  }

  function getBookLink({ fileSuffix, format, name }, code, i) {
    const suffix = !!fileSuffix ? `-${fileSuffix}` : "";
    return (
      <a
        key={i}
        href={`${process.env.REACT_APP_API_URL}/${format}/courses/${code}${suffix}.${format}`}
        target="_blank"
        rel="noopener"
        className="btn"
      >
        {name}
      </a>
    );
  }

  function getBooks({ courseBooks, code }) {
    const references = courseBooks.filter((r) => !r.isAnswerBook).reverse();
    const answers = courseBooks.filter((r) => r.isAnswerBook);

    const referencesList = references.map((book, i) =>
      getBookLink(book, code, i)
    );
    const answersList = answers.map((book, i) => getBookLink(book, code, i));

    const referenceSection =
      references.length > 0 ? <div>{referencesList}</div> : null;

    const answerSection = answers.length > 0 ? <div>{answersList}</div> : null;

    return (
      <div>
        {referenceSection}
        {answerSection}
      </div>
    );
  }

  return (
    <div className="course-card">
      <Link
        to={"/course/" + course.code}
        className="course-card__image-link"
        style={{ textDecoration: "none" }}
      >
        <div className="course-card__image-container">
          <ImgManaged src={image} type={"Booklets"} width={100} alt={course.title} />
        </div>
      </Link>
      <div className="course-card__content">
        <Link to={"/course/" + course.code} style={{ textDecoration: "none" }}>
          <div className="course-card__title">
            <p>{course.title}</p>
          </div>
          <p className="course-card__author">{course.author.name}</p>
        </Link>
        <div className="course-card__actions">
          <Dropdown isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle caret className="btn-light dropdown-toggle">
              <i className="fa fa-arrow-down fa-3" aria-hidden="true"></i>
              <span className="ms-2">{t("download-as")}</span>
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem header>{t("download-as")}:</DropdownItem>
              {getBooks(course)}
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
